import Moment from 'moment';

function futureDateValidator({ input, msgs }) {
  const FORMAT = 'MM/DD/YYYY';
  const today = new Moment();

  const isValidFormat = Moment(input, FORMAT).format(FORMAT) === input;

  if (!isValidFormat) {
    if (msgs && msgs.dateFormat) {
      return msgs.dateFormat;
    }
    return 'Please enter valid date using MM/DD/YYYY format';
  }

  if (!Moment(input, FORMAT).isAfter(today, 'day') && !Moment(input, FORMAT).isSame(today, 'day')) {
    if (msgs && msgs.futuredate) {
      return msgs.futuredate;
    }
    return 'Date must be in the future';
  }

  const futureDate = Moment().add(50, 'year').format(FORMAT);

  if (!Moment(input, FORMAT).isBefore(futureDate, 'day')) {
    if (msgs && msgs.futureDateOutOfRange) {
      return msgs.futureDateOutOfRange;
    }
    return 'This date must not be more than 50 years in the future';
  }

  return null;
}

export default futureDateValidator;
